module.exports = __webpack_public_path__ + "img/superprize.68c524a6.jpg";